export enum UserStates {
    MobileUploadNumber = 'mobile-upload-number',
    EnrollmentVerifyEmail = 'enrollment-verify-email',
    EnrollmentMfa = 'enrollment-mfa',
    EnrollmentSupplierAgreement = 'enrollment-vendor-agreement',
    EnrollmentBankAccount = 'enrollment-bank-account',
    GetCustomersRequest = 'getCustomersRequest',
    ListCustomerSummaryRequest = 'listCustomerSummaryRequest'
}
